<template>
  <view :class="containerClass" :style="style" :flex="containerFlex">
    <template v-if="direction === 'right'">
      <view class="text-title" :style="titleStyle">{{ title }}</view>
      <template v-if="componentLoading">
        <Loading />
      </template>
      <view v-else class="text-data" flex="dir:left cross:bottom">
        <view class="data-val" :style="dataStyle">
          {{ formatData(dataVal || data) }}
        </view>
      </view>
      <view class="line"></view>
    </template>
    <template v-else>
      <view class="line left"></view>
      <view class="text-title" :style="titleStyle">{{ title }}</view>
      <template v-if="componentLoading">
        <Loading />
      </template>
      <view v-else class="text-data" flex="dir:left cross:bottom">
        <view class="data-val" :style="dataStyle">
          {{ formatData(dataVal || data) }}
        </view>
      </view>
    </template>
  </view>
</template>
<script lang="ts" setup>
import { ref, computed } from "vue"
import Loading from "@p-v/packages/Loading.vue"
import numeral from "numeral"

interface DataTextProps {
  title: string
  data: string
  format?: string
  style?: { [key: string]: string | number }
  titleStyle?: { [key: string]: string | number }
  dataStyle?: { [key: string]: string | number }
  flex?: string
  direction?: string
}

const props = withDefaults(defineProps<DataTextProps>(), {
  title: () => "",
  data: () => "",
  format: () => "0,0",
  style: () => ({}),
  titleStyle: () => ({}),
  dataStyle: () => ({}),
  direction: () => "right",
  flex: undefined,
})

const containerFlex = computed(() => {
  if (!props.flex) {
    if (props.direction === "left") {
      return "dir:left main:left cross:center"
    } else {
      return "dir:left main:right cross:center"
    }
  }
  return props.flex
})

const containerClass = computed(() => {
  return {
    "pft-data-text-3-container-component": true,
    left: props.direction === "left",
  }
})

const formatData = (val: string) => {
  if (val === undefined || val === null) {
    return ""
  }
  if (/\d+/.test(val) === false) {
    return val
  }
  return numeral(Number(val)).format(props.format)
}

const componentLoading = ref<boolean>(true)

const dataVal = ref<string>("")

const loading = () => {
  componentLoading.value = true
}

const setData = (val: string) => {
  componentLoading.value = false
  dataVal.value = val
}

defineExpose({ loading, setData })
</script>
<style lang="scss">
.pft-data-text-3-container-component {
  position: relative;
  box-sizing: border-box;
  padding: 8px 22px 8px 16px;
  width: 100%;
  height: 40px;
  background: linear-gradient(90deg, rgba(67, 145, 255, 0) 0%, rgba(67, 145, 255, 0.5) 100%);
  &.left {
    background: linear-gradient(90deg, rgba(67, 145, 255, 0.5) 0%, rgba(67, 145, 255, 0) 100%);
  }
  .text-title {
    font-family:
      Segoe UI,
      Segoe UI;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
    flex-shrink: 0;
  }
  .text-data {
    margin-left: 12px;
    .data-val {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: bold;
      font-size: 20px;
      color: #4cb7ff;
    }
    .data-suffix {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.65);
      margin-left: 2px;
    }
    .data-percent {
      font-family:
        Segoe UI,
        Segoe UI;
      font-weight: 400;
      font-size: 12px;
      color: #fcf072;
      margin-left: 8px;
    }
  }
  .line {
    position: absolute;
    top: 0;
    right: 0;
    width: 6px;
    height: 40px;
    background: #2b97f7;
    border-radius: 0px 0px 0px 0px;
    &.left {
      left: 0;
      right: auto;
    }
  }
}
</style>
